export const separateColor = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const color_swatches = Array.from(document.querySelectorAll(".color-swatch-wrapper"));
        const saleSegment = document.querySelector("#saleSegment");
        const seasonalSegment = document.querySelector("#seasonalSegment");
        const normalSegment = document.querySelector("#normalSegment");
        const hiddenSegment = document.querySelector("#hiddenSegment");

        if ( color_swatches ) {
            if ( saleSegment && seasonalSegment && normalSegment && hiddenSegment) {
                color_swatches.forEach( element => {
                    if ( element.querySelector(".color-swatch") && element.querySelector(".color-swatch").dataset.isHidden == "true" ) {
                        hiddenSegment.appendChild(element); 
                    } else if (  element.querySelector(".color-swatch") && element.querySelector(".color-swatch").dataset.isSeasonal == "true" ) {
                        seasonalSegment.appendChild(element);
                    } else if (  element.querySelector(".color-swatch") && element.querySelector(".color-swatch").dataset.isSale == "true" ) {
                        saleSegment.appendChild(element);
                    } else {
                        normalSegment.appendChild(element);
                    }
                });
            }
        }

        if ( seasonalSegment && !seasonalSegment.hasChildNodes() ) {
            seasonalSegment.parentElement.style.display = "none";
        }
        if ( saleSegment && !saleSegment.hasChildNodes() ) {
            saleSegment.parentElement.style.display = "none";
        }
        if ( normalSegment && !normalSegment.hasChildNodes() ) {
            normalSegment.parentElement.style.display = "none";
        }
        if (hiddenSegment ) {
            hiddenSegment.parentElement.style.display = "none";
        }
    })
}